/**
 * Shared UI helpers for Mapbox popups/markers to keep Open Houses + Listings consistent.
 */

/**
 * Apply a subtle "modal-like" enter animation to a Mapbox popup.
 * Relies on CSS in `src/styles/map-popups.css`.
 *
 * @param {import('mapbox-gl').Popup} popup
 */
export function animatePopupIn(popup) {
  try {
    const el = popup?.getElement?.();
    if (!el) return;
    // Reset classes so repeated open/close always animates.
    el.classList.remove('popup-animate-in--active');
    el.classList.remove('popup-animate-in');
    el.classList.add('popup-animate-in');
    // Force a frame so the initial state is applied, then transition to active.
    requestAnimationFrame(() => {
      el.classList.add('popup-animate-in--active');
    });
  } catch {
    // no-op
  }
}

/**
 * Ensure the selected marker sits above other markers (so it never "falls behind").
 *
 * @param {import('mapbox-gl').Marker} marker
 * @param {{ isSelected: boolean, isHovered?: boolean }} state
 */
export function setMarkerStacking(marker, { isSelected, isHovered = false }) {
  const el = marker?.getElement?.();
  if (!el) return;
  // Keep markers below UI controls; only relative ordering among markers matters.
  el.style.zIndex = isSelected ? '3' : (isHovered ? '2' : '1');
}


